import { EvtHeader } from "components/header";
import { Icon } from "components/index";
import { AVERAGE } from "icons";
import { Button } from "ui/components/button";
import { EvtEmployeeLoaderCard } from "components/employee/loader";

export function ReceivedReviewsLoader() {
  return (
     <div>
            <EvtHeader title="Reviews">
              <Button variant="outline">
                <Icon icon={AVERAGE} className="w-4 h-4" />
                Average
              </Button>
            </EvtHeader>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 px-4 lg:px-6">
              {Array.from({ length: 4 }).map((_, index) => (
                <EvtEmployeeLoaderCard key={index} />
              ))}
            </div>
          </div>
  );
}
